import { datesDictionary, sportDictionary } from "../../../modes";

export type dictionary = sportDictionary | datesDictionary;

export const sportsDict: sportDictionary = {
    favorites: "Favorites",
    allSports: "All Sports",
    streaming: "Live Streaming"
}

export const datesDict: datesDictionary = {
    Today: "Today",
    Tomorrow: "Tomorrow",

    Monday: "Monday",
    Tuesday: "Tuesday",
    Wednesday: "Wednesday",
    Thursday: "Thursday",
    Friday: "Friday",
    Saturday: "Saturday",
    Sunday: "Sunday",

    January: "January",
    February: "February",
    March: "March",
    April: "April",
    May: "May",
    June: "June",
    July: "July",
    August: "August",
    September: "September",
    October: "October",
    November: "November",
    December: "December"
}